import styled from 'styled-components'
import { RemovedUserRecord } from 'Services/apiResponseTypes'
import { spacingMD, spacingSM } from 'Utils/styles/spacing'
import { frostedGlass, red, towerGray, zirconGray } from 'Utils/styles/colors'
import { AlertBanner } from 'Components/AlertBanner/AlertBanner'
import { AppIconMap, AppIcons } from 'Utils/types/appIcons'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

const TableContainer = styled.div`
  overflow-y: auto;
  border: 1px solid ${zirconGray};
  border-radius: 4px;
  max-height: calc(80vh - 500px);
`

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
`

const Thead = styled.thead`
  position: sticky;
  top: 0;
  background-color: ${frostedGlass};
  z-index: 1;
`

const TheadTr = styled.tr`
  box-shadow: 0 2px 2px -2px ${towerGray};
`

const Th = styled.th`
  padding: ${spacingSM};
  text-align: left;
  white-space: nowrap;
`

const Tr = styled.tr`
  &:nth-child(even) {
    background-color: ${frostedGlass};
  }

  &:hover {
    background-color: ${zirconGray};
  }
`

const Td = styled.td`
  padding: ${spacingSM};
  border-bottom: 1px solid ${zirconGray};
`

const EmptyState = styled.div`
  padding: ${spacingSM};
  text-align: center;
  color: ${towerGray};
  font-style: italic;
`

const StatusBadge = styled.span`
  background-color: ${frostedGlass};
  color: ${towerGray};
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
`

type RemovalsTabProps = {
  users: RemovedUserRecord[]
}

export const RemovalsTab = ({ users }: RemovalsTabProps) => {
  if (users.length === 0) {
    return <EmptyState>No users to remove</EmptyState>
  }

  return (
    <Container>
      <AlertBanner
        alert="WARNING: This action cannot be undone. Please review carefully before confirming."
        style={{
          padding: 10,
          marginBottom: spacingMD,
          border: `1px solid ${red}`,
          backgroundColor: '#ffebee',
          width: 778
        }}
        iconSrc={AppIconMap[AppIcons.Warning]}
      />

      <TableContainer>
        <Table>
          <Thead>
            <TheadTr>
              <Th>User</Th>
              <Th>Email</Th>
              <Th>Country</Th>
              <Th>Current Status</Th>
              <Th>Termination Date</Th>
            </TheadTr>
          </Thead>
          <tbody>
            {users.map((user) => (
              <Tr key={user.user_id}>
                <Td>
                  {user.first_name} {user.last_name}
                </Td>
                <Td>{user.email}</Td>
                <Td>{user.country_code}</Td>
                <Td>
                  <StatusBadge>{user.current_status}</StatusBadge>
                </Td>
                <Td>{user.termination_date}</Td>
              </Tr>
            ))}
          </tbody>
        </Table>
      </TableContainer>
    </Container>
  )
}
